import { create } from 'zustand';
import { ExtendedCountryCode } from '_/helpers/countryDials';

interface CountryPickerState {
  countryPickerOpen: boolean;
  countryPickerCallback: ((code: ExtendedCountryCode) => void) | null;

  openCountryPicker: (callback: (code: ExtendedCountryCode) => void) => void;
  closeCountryPicker: () => void;
}

export const useCountryPickerStore = create<CountryPickerState>((set) => ({
  countryPickerOpen: false,
  countryPickerCallback: null,
  openCountryPicker: (callback) =>
    set({
      countryPickerOpen: true,
      countryPickerCallback: callback,
    }),
  closeCountryPicker: () =>
    set({
      countryPickerOpen: false,
      countryPickerCallback: null,
    }),
}));
